import * as _ from 'lodash'

// have to escapse single quotes
// with another single quote before encoding
export function escapeText(value: string): string {
  return `'${encodeURIComponent(_.replace(value.toLowerCase(), "'", "''"))}'`
}
